import { PostEditBaseCtrl } from 'components/sharpr/post/service/PostEditBaseCtrl';
import { ensure } from 'components/sharpr/ensure/ensure';
import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import spinner from 'components/sharpr/spinner/SpinnerSingleton';
import { UrlModel } from '../../../sharpr/url/model/UrlModel.js';

export function PostCreateRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.PostCreate', {
		url: '/post/new',
		controllerAs: 'vm',
		controller: PostCreateCtrl,
		templateUrl: '/ng/hub/Post/Edit/PostEditCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Post/Edit/PostEditCtrl.css'),
			$title: () => 'Create New Post',
		},
	});
}

export class PostCreateCtrl extends PostEditBaseCtrl {
	constructor(Identity, Theme, Api, Cfg, AutoArchive, FileDrag, $q, $timeout, $interval, modal) {
		'ngInject';
		super();
		// save injections
		this.Identity = Identity;
		this.Theme = Theme;
		this.Api = Api;
		this.Cfg = Cfg;
		this.AutoArchive = AutoArchive;
		this.FileDrag = FileDrag;
		this.$q = $q;
		this.$timeout = $timeout;
		this.$interval = $interval;
		this.modal = modal;

		this.setup();
	}

	async setup() {
		await super.setup();
		this.mode = 'create';
		this.setupResearchManagement();
		this.resetPost();
		this.loadTaxonomy();
		this.setupLabels();
		this.setupMessenger();
		this.checkAndLoadProvidedUrl();
		this.allowedExtensions = [];
	}

	/**
	 * Load a URL automatically if it's provided in the query string after the hash
	 * E.g., /hub#/post/new?url=https:%2F%2Fgoogle.com will automatically scrape https://google.com and load the
	 * details into the form.
	 */
	checkAndLoadProvidedUrl() {
		if (window.location.hash.split('?')[1]) {
			const queryStringAfterHash = window.location.hash.split('?')[1];
			const values = UrlModel.parse(queryStringAfterHash);

			if (values?.url) {
				this.originUrl = values.url;
				this.fetchUrl();
			}
		}
	}

	setupMessenger() {
		try {
			this.messenger = new window.CrossWindowMessenger(window.parent, '*');
		} catch (e) {
			//do noting since this functionality isn't mission critical. It's only used when react is iframing in angular
		}
	}

	onBeforeModalExit() {
		if (this.isUploading()) {
			return this.pleaseWaitForUpload();
		} else if (!this.isSaving && !this.isCanceling) {
			return this.modal.confirm({
				text: "Post hasn't been saved yet.",
				confirmText: 'Discard',
				cancelText: 'Continue Editing',
			});
		}
		super.onExit();
	}

	cancel() {
		ensure.promise(this.onBeforeModalExit()).then(
			() => {
				this.isCanceling = true;
				if (typeof this.$reject === 'function') {
					this.$reject();
				}
			},
			() => {}
		);
	}

	save() {
		if (this.isUploading()) {
			// TODO: make user wait until document is processed?
			return this.pleaseWaitForUpload();
		}

		const validation = this.validatePost(this.post);

		if (validation.success) {
			this.saveNew()
				.then(postId => {
					if (this.canAddToInsightBrief) {
						this.saveInsightBriefChoices(postId);
					}
					const redirectUrl = this.Cfg.read('Features.url_to_open_after_post_submit');

					if (typeof this.$resolve === 'function') {
						this.$resolve(postId);
					}

					if (redirectUrl) {
						window.location.href = `${redirectUrl}/${postId}`;
					} else {
						this.messenger.post('success', { postId: postId });
					}
				})
				.catch(err => {
					this.isSaving = false;
					this.handleErrors(err);
				});
		} else {
			spinner.stopAll();
			this.showErrorsModal(validation.errors);
		}
	}

	/**
	 * This helper method synchronously adds new elements_stories records for all post/story combinations acquired from the message service.
	 * NOTE: This is an "async" method so that we can specifically "await" the API request. We want to ensure that the values
	 * are saved in the database before returning focus to the over all "saveNew" handler and subsequent posting of "success"
	 * to the messenger.
	 * @param postId
	 * @returns void
	 */
	async saveInsightBriefChoices(postId) {
		// If the storyIds property was populated as an array, add all its values to the elements_stories database table.
		if (Array.isArray(this.storyIds) && this.canAddToInsightBrief) {
			for (const storyId of this.storyIds) {
				await this.Api.request('PUT', `/stories/${storyId}/add_post`, { post_id: postId });
			}
		}
	}
}
